import { appRoutesConfig } from 'src/app/app-routes.config';

export class UrlUtils {
	public static safeRedirectTarget(value: string | null | undefined): string {
		if (!value || typeof value !== 'string') return appRoutesConfig.home.url;
		if (!value.startsWith('/')) return appRoutesConfig.home.url;
		if (value.startsWith('//')) return appRoutesConfig.home.url;
		if (value === appRoutesConfig.login.url) return appRoutesConfig.home.url;
		if (value.startsWith(`${appRoutesConfig.login.url}/`)) return appRoutesConfig.home.url;
		return value;
	}

	public static isSafeRedirectPath(url: string | null | undefined): url is string {
		if (!url || typeof url !== 'string') return false;
		if (!url.startsWith('/')) return false;
		if (url.startsWith('//')) return false;
		if (url === appRoutesConfig.login.url) return false;
		if (url.startsWith(`${appRoutesConfig.login.url}/`)) return false;
		return true;
	}
}
